// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  box-sizing: inherit;
  height: 100%;
  font-size: 10px;
}

:root {
  --base-node-size: 20px;
  
  /* Modern Color Palette */
  --primary-blue: #0F4C75;
  --secondary-blue: #3282B8;
  --accent-blue: #0F4C75;
  --light-blue: #BBE1FA;
  --dark-navy: #1B2951;
  --ocean-blue: #2E86AB;
  --sea-foam: #A23B72;
  --coral: #F18F01;
  --deep-water: #0A2342;
  --surface-blue: #205295;
  
  /* UI Colors */
  --bg-primary: linear-gradient(135deg, #0F4C75 0%, #3282B8 100%);
  --bg-secondary: linear-gradient(135deg, #1B2951 0%, #0F4C75 100%);
  --bg-dark: #0A2342;
  --text-primary: #FFFFFF;
  --text-secondary: #BBE1FA;
  --border-color: rgba(187, 225, 250, 0.3);
  --shadow-light: rgba(50, 130, 184, 0.2);
  --shadow-dark: rgba(10, 35, 66, 0.4);
  
  /* Ship Colors */
  --ship-color: #F18F01;
  --ship-hit: #E74C3C;
  --ship-sunk: #C0392B;
  --water-miss: #7FB3D3;
  --water-hit: #E74C3C;
  
  /* Success/Error */
  --success: #27AE60;
  --warning: #F39C12;
  --error: #E74C3C;
}

body {
  font-size: 1.6rem;
  line-height: 1.5;
  letter-spacing: 0.5px;
  height: 100vh;
  min-height: 100vh;
  text-transform: lowercase;
  font-family: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-weight: 400;
  overflow-x: hidden;
}

dialog {
  margin: auto;
  border: none;
  border-radius: 16px;
  min-width: 280px;
  min-height: 200px;
  width: 85%;
  background: var(--bg-secondary);
  color: var(--text-primary);
  box-shadow: 0 20px 60px var(--shadow-dark), 0 8px 25px var(--shadow-light);
  backdrop-filter: blur(10px);
  animation: modalSlideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  transition: all 0.3s ease;
}

@keyframes modalSlideIn {
  from {
    transform: scale(0.8) translateY(-20px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

dialog::backdrop {
  background: rgba(10, 35, 66, 0.7);
  backdrop-filter: blur(4px);
  animation: backdropFadeIn 0.3s ease;
}

@keyframes backdropFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

button:active,
button:focus {
  outline: none;
}

/* Global transitions */
* {
  transition: all 0.2s ease;
}

*:focus-visible {
  outline: 2px solid var(--accent-blue);
  outline-offset: 2px;
}

ul {
  list-style: none;
}

.z_index_1 {
  z-index: 1;
}

.z_index_2 {
  z-index: 2;
}

.z_index_3 {
  z-index: 3;
}

.hidden {
  display: none;
}

.icon_container {
  width: 2.5rem;
  height: 2.5rem;
  padding: 8px;
  box-sizing: initial;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

.icon_container:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
  box-shadow: 0 4px 15px var(--shadow-light);
}

.cursor_pointer {
  cursor: pointer;
}

.cursor_crosshair {
  cursor: crosshair;
}

.img,
img {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}

.text-align__center {
  text-align: center;
}

.text-align__center1 {
  text-align: center;
  display: block;
  width: 100%;
}

.text-transform__uppercase {
  text-transform: uppercase;
}

.text-transform__capitalize {
  text-transform: capitalize;
}

.text-transform__lowercase {
  text-transform: lowercase;
}

.container {
  width: 100%;
  max-width: 1128px;
  position: relative;
}

.d-flex__row {
  display: flex;
  flex-direction: row;
}

.d-flex__col {
  display: flex;
  flex-direction: column;
}

.flex-direction__col {
  flex-direction: column;
}

.flex-direction__row {
  flex-direction: row;
}

.justify-content__center {
  justify-content: center;
}

.justify-content__space-around {
  justify-content: space-around;
}
.justify-content__space-between {
  justify-content: space-between;
}

.align-items__center {
  align-items: center;
}

.centered_flex {
  justify-content: center;
  align-items: center;
}

.gap_10 {
  gap: 10px;
}

.gap_5 {
  gap: 5px;
}

.gap_2 {
  gap: 2px;
}

.gap_1r {
  gap: 1rem;
}

.gap_2r {
  gap: 2rem;
}

.d-flex {
  display: flex;
}

.padding-top_10 {
  padding-top: 10px;
}

.padding-bottom_10 {
  padding-bottom: 10px;
}

.padding-left_10 {
  padding-left: 10px;
}

.padding-right_10 {
  padding-right: 10px;
}

.padding_10 {
  padding: 10px;
}

.padding_2r {
  padding: 2rem;
}

.btn {
  cursor: pointer;
  border: none;
  outline: none;
  background: linear-gradient(135deg, var(--secondary-blue) 0%, var(--primary-blue) 100%);
  color: var(--text-primary);
  font-family: inherit;
  font-weight: 600;
  border-radius: 12px;
  padding: 12px 24px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(50, 130, 184, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 1.4rem;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(50, 130, 184, 0.4);
  background: linear-gradient(135deg, var(--ocean-blue) 0%, var(--secondary-blue) 100%);
}

.btn:hover::before {
  left: 100%;
}

.btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(50, 130, 184, 0.3);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.fz_2-4r {
  font-size: 2.4rem;
}

.fz_2r {
  font-size: 2rem;
}

.fz_1-8r {
  font-size: 1.8rem;
}

.fz_1-4r {
  font-size: 1.4rem;
}

/* LOADING SCREEN */

.loading-title {
  text-align: center;
  animation: titleFadeIn 1s ease-out;
}

.loading-title h1 {
  font-size: 1.8rem;
  letter-spacing: 3px;
  font-weight: 300;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
  animation: slideInFromTop 0.8s ease-out;
}

.loading-title h2 {
  font-size: 4rem;
  letter-spacing: 2px;
  font-weight: 700;
  background: linear-gradient(135deg, var(--text-primary) 0%, var(--light-blue) 50%, var(--secondary-blue) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: slideInFromBottom 0.8s ease-out 0.2s both;
}

.loading-screen {
  height: 100%;
  text-align: center;
  background: var(--bg-primary);
  position: relative;
  overflow: hidden;
}

.loading-screen::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(50, 130, 184, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(15, 76, 117, 0.1) 0%, transparent 50%);
  animation: backgroundPulse 4s ease-in-out infinite;
}

@keyframes backgroundPulse {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.7; }
}

@keyframes titleFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slideInFromTop {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInFromBottom {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.loading-bar {
  height: auto;
  width: 100%;
  position: relative;
  z-index: 1;
}

.loading-line {
  height: calc(var(--base-node-size) + 4px);
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  border: 2px solid var(--border-color);
  overflow: hidden;
  position: relative;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px var(--shadow-dark);
}

.line {
  height: 100%;
  border-radius: 25px;
  background: linear-gradient(90deg, var(--secondary-blue) 0%, var(--coral) 50%, var(--ocean-blue) 100%);
  animation: loading 2.5s cubic-bezier(0.4, 0, 0.2, 1) 200ms forwards,
             shimmer 2s ease-in-out infinite;
  position: relative;
  overflow: hidden;
}

.line::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: slideShimmer 1.5s ease-in-out infinite;
}

@keyframes slideShimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.loading-screen.loading-complete .line {
  background: linear-gradient(90deg, var(--success) 0%, var(--ocean-blue) 100%);
  box-shadow: 0 0 20px rgba(39, 174, 96, 0.5);
}

.loading-screen.loading-complete .loading-line {
  border-color: var(--success);
  box-shadow: 0 4px 20px rgba(39, 174, 96, 0.3);
}

@keyframes loading {
  0% {
    width: 0%;
    transform: scaleX(0);
  }
  100% {
    width: 100%;
    transform: scaleX(1);
  }
}

@keyframes shimmer {
  0%, 100% {
    filter: brightness(1);
  }
  50% {
    filter: brightness(1.2);
  }
}

.loading-text {
  font-size: 1.6rem;
  letter-spacing: 1.5px;
  color: var(--text-secondary);
  animation: textPulse 2s ease-in-out infinite;
}

@keyframes textPulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

.loader {
  display: inline-block;
  margin-left: 8px;
  width: 28px;
  aspect-ratio: 4;
  background: radial-gradient(circle closest-side, var(--secondary-blue) 90%, transparent) 0 /
    calc(100% / 3) 100% space;
  clip-path: inset(0 100% 0 0);
  animation: l1 1.5s steps(4) infinite;
}

@keyframes l1 {
  to {
    clip-path: inset(0 -34% 0 0);
  }
}

/* LOADING SCREEN ENDS */

/* HOME PAGE */
.home-page {
  height: 100%;
  background: var(--bg-primary);
  position: relative;
  overflow: hidden;
}

.home-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 30% 20%, rgba(50, 130, 184, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 80%, rgba(15, 76, 117, 0.15) 0%, transparent 50%);
  animation: homeBackgroundFloat 6s ease-in-out infinite;
}

@keyframes homeBackgroundFloat {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(1deg); }
}

.home-page .container {
  position: relative;
  z-index: 1;
  animation: containerSlideIn 0.8s ease-out;
}

@keyframes containerSlideIn {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.home-page__title {
  font-size: 4.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--text-primary) 0%, var(--light-blue) 50%, var(--coral) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 8px var(--shadow-dark);
  animation: titleGlow 3s ease-in-out infinite;
}

@keyframes titleGlow {
  0%, 100% { filter: brightness(1); }
  50% { filter: brightness(1.2); }
}

.home-page__btn-group {
  width: 60%;
  max-width: 280px;
  animation: buttonsSlideIn 0.8s ease-out 0.3s both;
}

@keyframes buttonsSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.home-page__btn-group .btn {
  padding: 16px 32px;
  font-size: 1.6rem;
  font-weight: 600;
  min-width: 140px;
}

.tutorial-btn-container {
  position: absolute;
  top: 30px;
  left: 30px;
  animation: tutorialFadeIn 1s ease-out 0.5s both;
}

@keyframes tutorialFadeIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.tutorial__btn {
  padding: 16px 32px;
  font-size: 1.6rem;
  font-weight: 600;
  min-width: 140px;
  display: none; /* Hidden by default, shown on small screens */
}

/* Desktop: Show icon tutorial button, hide text tutorial button */
@media (min-width: 768px) {
  .tutorial-btn-container {
    display: block;
  }
  
  .tutorial__btn {
    display: none;
  }
}

/* Mobile/Tablet: Hide icon tutorial button, show text tutorial button */
@media (max-width: 767px) {
  .tutorial-btn-container {
    display: none;
  }
  
  .tutorial__btn {
    display: block;
  }
}
/* HOME PAGE ENDS */

/* GAME SETUP PAGE */
.game-setup {
  min-height: 100vh;
  text-align: center;
  background: var(--bg-primary);
  position: relative;
  padding: 1rem 0;
}

.game-setup::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 15% 25%, rgba(50, 130, 184, 0.1) 0%, transparent 40%),
    radial-gradient(circle at 85% 75%, rgba(241, 143, 1, 0.08) 0%, transparent 40%);
  animation: setupBackgroundDrift 8s ease-in-out infinite;
}

@keyframes setupBackgroundDrift {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-5px, -10px) scale(1.02); }
}

.game-setup .container {
  justify-content: center;
  position: relative;
  z-index: 1;
  animation: setupContainerFadeIn 0.6s ease-out;
}

@keyframes setupContainerFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.board {
  display: grid;
  grid-template-columns: var(--base-node-size) 1fr;
  grid-template-rows: var(--base-node-size) 1fr;
  grid-template-areas:
    '. row-label'
    'col-label board-items';
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  box-shadow: 0 8px 32px var(--shadow-dark);
  transition: all 0.3s ease;
  width: fit-content;
  margin: 0 auto;
  box-sizing: border-box;
}

.board:hover {
  box-shadow: 0 12px 40px var(--shadow-dark);
  border-color: rgba(187, 225, 250, 0.5);
}

.bot-player-board {
  grid-template-columns: 1fr var(--base-node-size);
  grid-template-areas:
    'row-label .'
    'board-items col-label';
}

.board-item-container {
  grid-area: board-items;
  display: grid;
  grid-template-columns: repeat(10, var(--base-node-size));
  grid-template-rows: repeat(10, var(--base-node-size));
  grid-template-areas:
    'X0-Y0 X1-Y0 X2-Y0 X3-Y0 X4-Y0 X5-Y0 X6-Y0 X7-Y0 X8-Y0 X9-Y0'
    'X0-Y1 X1-Y1 X2-Y1 X3-Y1 X4-Y1 X5-Y1 X6-Y1 X7-Y1 X8-Y1 X9-Y1'
    'X0-Y2 X1-Y2 X2-Y2 X3-Y2 X4-Y2 X5-Y2 X6-Y2 X7-Y2 X8-Y2 X9-Y2'
    'X0-Y3 X1-Y3 X2-Y3 X3-Y3 X4-Y3 X5-Y3 X6-Y3 X7-Y3 X8-Y3 X9-Y3'
    'X0-Y4 X1-Y4 X2-Y4 X3-Y4 X4-Y4 X5-Y4 X6-Y4 X7-Y4 X8-Y4 X9-Y4'
    'X0-Y5 X1-Y5 X2-Y5 X3-Y5 X4-Y5 X5-Y5 X6-Y5 X7-Y5 X8-Y5 X9-Y5'
    'X0-Y6 X1-Y6 X2-Y6 X3-Y6 X4-Y6 X5-Y6 X6-Y6 X7-Y6 X8-Y6 X9-Y6'
    'X0-Y7 X1-Y7 X2-Y7 X3-Y7 X4-Y7 X5-Y7 X6-Y7 X7-Y7 X8-Y7 X9-Y7'
    'X0-Y8 X1-Y8 X2-Y8 X3-Y8 X4-Y8 X5-Y8 X6-Y8 X7-Y8 X8-Y8 X9-Y8'
    'X0-Y9 X1-Y9 X2-Y9 X3-Y9 X4-Y9 X5-Y9 X6-Y9 X7-Y9 X8-Y9 X9-Y9';
}

.board-item.can-receive-ship {
  background-color: rgba(0, 225, 0, 0.5);
}

.board-item.cannot-receive-ship {
  background-color: rgba(225, 0, 0, 0.5);
}

.row-label {
  grid-area: row-label;
  display: grid;
  grid-template-columns: repeat(10, var(--base-node-size));
  font-size: 1.4rem;
}

.col-label {
  grid-area: col-label;
  display: grid;
  grid-template-rows: repeat(10, var(--base-node-size));
  font-size: 1.4rem;
}

.label-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--base-node-size);
  height: var(--base-node-size);
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-color);
  text-align: center;
}

.home-btn-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

.home-btn-container .btn {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 20px var(--shadow-dark);
  border-radius: 12px;
  padding: 12px;
}

.home-btn-container .btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px var(--shadow-dark);
}

.ship-yard {
  display: flex;
  margin-bottom: 2rem;
  align-items: flex-start;
  justify-content: space-around;
  background: rgba(255, 255, 255, 0.05);
  padding: 24px;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  box-shadow: 0 8px 32px var(--shadow-dark);
  position: relative;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.ship-yard::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(50, 130, 184, 0.05) 0%, rgba(241, 143, 1, 0.05) 100%);
  border-radius: 16px;
  pointer-events: none;
}

.ship-node {
  background-color: #6565f5;
  width: var(--base-node-size);
  height: var(--base-node-size);
  border-radius: 3px;
}

.ship[data-orientation='HORIZONTAL'] {
  flex-direction: row;
}

.ship[data-orientation='VERTICAL'] {
  flex-direction: column;
}

.btn-group .btn {
  padding: 10px 18px;
  font-size: 1.5rem;
  min-width: 120px;
  box-shadow: 0 4px 15px rgba(50, 130, 184, 0.3);
}

.btn.rotate {
  padding: 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 15px var(--shadow-light);
}

.btn.rotate:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1) rotate(90deg);
  box-shadow: 0 6px 20px var(--shadow-light);
}

.ship.active .ship-node {
  background-color: green;
}

.ship.place {
  z-index: 2;
}

.ship.fail-place .ship-node {
  background-color: red;
}

/* GAME SETUP PAGE ENDS */

/* GAME PLAY PAGE START */

.game-play-container {
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
}

.human-player-section-container {
  display: grid;
  gap: 1rem;
  grid-template-rows: auto 10px auto;
  max-width: 400px;
  order: 2;
  justify-items: center;
  flex: 1;
}

.bot-player-section-container {
  display: grid;
  gap: 1rem;
  grid-template-rows: auto 10px auto;
  max-width: 400px;
  justify-items: center;
  flex: 1;
}

.bot-player-section-container .ship.sunk .ship-node {
  background-color: red;
}

.water-header {
  font-size: 2rem;
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 600;
  background: linear-gradient(135deg, var(--text-primary) 0%, var(--light-blue) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 8px var(--shadow-dark);
  animation: headerGlow 4s ease-in-out infinite;
  white-space: nowrap;
}

@keyframes headerGlow {
  0%, 100% { filter: brightness(1); }
  50% { filter: brightness(1.15); }
}

.ship-yard-section-header {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-shadow: 0 2px 4px var(--shadow-dark);
  margin-bottom: 0.5rem;
  flex-shrink: 0;
}

.horizontal-divider-container {
  display: grid;
  width: 100%;
}

.vertical-divider-container {
  display: none;
  height: 100%;
  justify-items: center;
  grid-template-rows: 1fr 40px 1fr;
  gap: 2rem;
}

.game-dashboard-container .vertical-divider-container {
  display: grid;
  grid-template-rows: 1fr;
}

.small-screen_divider {
  display: grid;
  grid-template-columns: 1fr 40px 1fr;
  justify-content: center;
  align-items: center;
  justify-items: center;
}

.horizontal-divider {
  height: 3px;
  width: 100%;
  background: linear-gradient(90deg, var(--secondary-blue) 0%, var(--coral) 50%, var(--secondary-blue) 100%);
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(50, 130, 184, 0.5);
  animation: dividerPulse 3s ease-in-out infinite;
}

.vertical-divider {
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, var(--secondary-blue) 0%, var(--coral) 50%, var(--secondary-blue) 100%);
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(50, 130, 184, 0.5);
  animation: dividerPulse 3s ease-in-out infinite;
}

@keyframes dividerPulse {
  0%, 100% {
    box-shadow: 0 0 10px rgba(50, 130, 184, 0.5);
  }
  50% {
    box-shadow: 0 0 20px rgba(50, 130, 184, 0.7);
  }
}

.turn-marker {
  border: 2px solid green;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  align-self: center;
}

.game-dashboard-container {
  display: grid;
  gap: 1rem;
  align-items: center;
  justify-items: center;
  grid-template-columns: 2fr 10px 1fr;
}

.players-desc-container {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  justify-content: center;
  background: rgba(255, 255, 255, 0.08);
  padding: 12px 20px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 20px var(--shadow-dark);
}

.players-desc-container p {
  font-weight: 600;
  font-size: 1.8rem;
  color: var(--text-secondary);
  text-shadow: 0 2px 4px var(--shadow-dark);
}

.board-item[data-has-ship='true'][data-mask='false'] {
  background: linear-gradient(135deg, var(--ship-color) 0%, #E67E22 100%);
  border-color: var(--ship-color);
  box-shadow: 0 0 10px rgba(241, 143, 1, 0.4);
}

.board .board-item[data-hit-status='1'],
.board .board-item[data-hit-status='2'] {
  background: linear-gradient(135deg, var(--ship-hit) 0%, #C0392B 100%);
  border-color: var(--ship-hit);
  box-shadow: 0 0 15px rgba(231, 76, 60, 0.5);
  animation: hitFlash 0.5s ease-out;
}

.board .board-item[data-hit-status='0'],
.board .board-item[data-hit-status='3'] {
  background: linear-gradient(135deg, var(--water-miss) 0%, #5DADE2 100%);
  border-color: var(--water-miss);
  box-shadow: 0 0 8px rgba(127, 179, 211, 0.3);
  animation: missRipple 0.6s ease-out;
}

@keyframes hitFlash {
  0% {
    background: #FFFFFF;
    transform: scale(1.2);
  }
  100% {
    background: linear-gradient(135deg, var(--ship-hit) 0%, #C0392B 100%);
    transform: scale(1);
  }
}

@keyframes missRipple {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(127, 179, 211, 0.7);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(127, 179, 211, 0);
  }
}

.game-controls {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.turn-marker[data-turn-indicator='human'] {
  border-color: green;
  background-color: green;
}

.turn-marker[data-turn-indicator='bot'] {
  border-color: red;
  background-color: red;
}

.bot-ship-yard-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  padding: 1.2rem;
  max-width: 280px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  box-shadow: 0 8px 32px var(--shadow-dark);
  justify-content: center;
}

.bot-ship-yard-container .ship-node {
  width: 15px;
  height: 15px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-shadow: 0 2px 8px var(--shadow-light);
  transition: all 0.3s ease;
}

.bot-ship-yard-container .ship.sunk .ship-node {
  background: linear-gradient(135deg, var(--ship-sunk) 0%, #A93226 100%);
  border-color: var(--ship-sunk);
  box-shadow: 0 0 15px rgba(192, 57, 43, 0.5);
  animation: sunkGlow 2s ease-in-out infinite;
}

@keyframes sunkGlow {
  0%, 100% {
    box-shadow: 0 0 15px rgba(192, 57, 43, 0.5);
  }
  50% {
    box-shadow: 0 0 25px rgba(192, 57, 43, 0.7);
  }
}

.hidden_small {
  display: none;
}

/* Touch device optimizations */
@media (hover: none) and (pointer: coarse) {
  .btn {
    min-height: 44px;
    min-width: 44px;
    font-size: 1.6rem;
  }
  
  .board-item {
    width: var(--base-node-size);
    height: var(--base-node-size);
    min-width: var(--base-node-size);
    min-height: var(--base-node-size);
    max-width: var(--base-node-size);
    max-height: var(--base-node-size);
    box-sizing: border-box;
  }
  
  .icon_container {
    min-height: 44px;
    min-width: 44px;
  }
  
  .ship-node {
    min-height: 24px;
    min-width: 24px;
  }
}

/* High DPI displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .board {
    border-width: 0.5px;
  }
  
  .board-item {
    border-width: 0.5px;
  }
  
  .ship-node {
    border-width: 1px;
  }
}

/* Landscape mobile orientation */
@media (max-height: 500px) and (orientation: landscape) {
  .game-play-container {
    padding: 0.5rem;
  }
  
  .water-header {
    font-size: 1.8rem;
    margin-bottom: 0.5rem;
  }
  
  .players-desc-container {
    padding: 6px 12px;
  }
  
  .game-dashboard-container {
    padding: 8px;
  }
  
  .ship-yard {
    padding: 12px;
  }
}

/* Reduced motion preference */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  :root {
    --bg-primary: linear-gradient(135deg, #0A1929 0%, #1B2951 100%);
    --bg-secondary: linear-gradient(135deg, #0F1B2A 0%, #0A2342 100%);
    --text-primary: #FFFFFF;
    --text-secondary: #B0BEC5;
    --border-color: rgba(176, 190, 197, 0.2);
  }
}

/* GAME PLAY PAGE ENDS */

/* Accessibility improvements */
.btn:focus-visible,
.board-item:focus-visible,
.icon_container:focus-visible {
  outline: 3px solid var(--accent-blue);
  outline-offset: 2px;
  z-index: 10;
}

/* Screen reader only content */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* User Registration Styles */
.user-registration-dialog {
  min-width: 400px;
  max-width: 500px;
  width: 90%;
}

.registration-header {
  margin-bottom: 1rem;
}

.registration-icon {
  width: 4rem;
  height: 4rem;
  background: linear-gradient(135deg, var(--secondary-blue) 0%, var(--primary-blue) 100%);
  border-radius: 50%;
  padding: 1rem;
}

.registration-subtitle {
  color: var(--text-secondary);
  font-size: 1.4rem;
  margin: 0;
}

.username-input {
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid var(--border-color);
  color: var(--text-primary);
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 1.6rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.username-input:focus {
  border-color: var(--secondary-blue);
  box-shadow: 0 0 0 3px rgba(50, 130, 184, 0.2);
  outline: none;
  background: rgba(255, 255, 255, 0.15);
}

.username-input::placeholder {
  color: rgba(187, 225, 250, 0.6);
}

.username-help {
  color: var(--text-secondary);
  font-size: 1.2rem;
  margin: 0;
  opacity: 0.8;
}

.error-message {
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid var(--error);
  color: var(--error);
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 1.3rem;
  margin: 0;
  animation: errorShake 0.5s ease-in-out;
}

.success-message {
  background: rgba(39, 174, 96, 0.1);
  border: 1px solid var(--success);
  color: var(--success);
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 1.3rem;
  margin: 0;
  animation: successPulse 0.5s ease-in-out;
}

@keyframes errorShake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

@keyframes successPulse {
  0% { transform: scale(0.95); opacity: 0; }
  50% { transform: scale(1.02); }
  100% { transform: scale(1); opacity: 1; }
}

.join-btn {
  background: linear-gradient(135deg, var(--success) 0%, #27AE60 100%);
  min-width: 120px;
  font-weight: 600;
}

.join-btn:hover {
  background: linear-gradient(135deg, #27AE60 0%, var(--success) 100%);
  box-shadow: 0 8px 25px rgba(39, 174, 96, 0.4);
}

.join-btn:disabled {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
  transform: none;
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid var(--border-color);
  color: var(--text-secondary);
  min-width: 120px;
}

.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: var(--error);
  color: var(--error);
}

.online-users-section {
  border-top: 1px solid var(--border-color);
  padding-top: 1.5rem;
  margin-top: 1rem;
}

.online-users-header {
  color: var(--text-secondary);
  font-size: 1.4rem;
  margin: 0;
  font-weight: 600;
}

.online-users-list {
  min-height: 40px;
  max-height: 100px;
  overflow-y: auto;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--border-color);
  padding: 8px;
}

.online-user-tag {
  background: rgba(50, 130, 184, 0.2);
  color: var(--text-primary);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 1.2rem;
  border: 1px solid rgba(50, 130, 184, 0.3);
  white-space: nowrap;
  animation: userTagFadeIn 0.3s ease-out;
}

@keyframes userTagFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.online-users-empty {
  color: var(--text-secondary);
  font-style: italic;
  opacity: 0.7;
  font-size: 1.2rem;
}

/* Connection status indicator */
.connection-status {
  position: fixed;
  top: 70px;
  right: 20px;
  z-index: 1001;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: lowercase;
  backdrop-filter: blur(10px);
  border: 1px solid;
  transition: all 0.3s ease;
}

.connection-status.connected {
  background: rgba(39, 174, 96, 0.1);
  border-color: var(--success);
  color: var(--success);
}

.connection-status.disconnected {
  background: rgba(231, 76, 60, 0.1);
  border-color: var(--error);
  color: var(--error);
}

.connection-status.connecting {
  background: rgba(241, 143, 1, 0.1);
  border-color: var(--warning);
  color: var(--warning);
}

/* Print styles */
@media print {
  .btn,
  .icon_container,
  .tutorial-btn-container,
  .home-btn-container,
  .user-registration-dialog,
  .connection-status {
    display: none;
  }
  
  .board {
    border: 2px solid #000;
  }
  
  .board-item {
    border: 1px solid #000;
    background: #fff !important;
  }
  
  .board-item[data-has-ship='true'] {
    background: #ccc !important;
  }
}

.settings-page {
  min-height: 100%;
  background: var(--bg-primary);
  position: relative;
}

.settings-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 25% 25%, rgba(50, 130, 184, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 75% 75%, rgba(15, 76, 117, 0.1) 0%, transparent 50%);
  animation: settingsBackgroundFloat 10s ease-in-out infinite;
}

@keyframes settingsBackgroundFloat {
  0%, 100% { transform: scale(1) rotate(0deg); }
  50% { transform: scale(1.05) rotate(1deg); }
}

.settings-page .container {
  min-height: 100%;
  position: relative;
  z-index: 1;
}

.settings-page h1 {
  font-size: 3rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--text-primary) 0%, var(--light-blue) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 8px var(--shadow-dark);
}

.settings-page h2 {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-shadow: 0 2px 4px var(--shadow-dark);
}

.settings-form .horizontal-divider-container {
  display: flex;
}

.settings-form .horizontal-divider-container .horizontal-divider {
  display: none;
}

.music-controls-container,
.vibration-controls-container {
  background-position: center;
  background-repeat: no-repeat;
}

.volume-controls-container[data-volume='yes'] .btn.volume-mute-icon {
  display: none;
}

.volume-controls-container[data-volume='no'] .btn.volume-high-icon {
  display: none;
}

.vibrate-controls-container[data-vibrate='yes'] .btn.vibrate-off-icon {
  display: none;
}

.vibrate-controls-container[data-vibrate='no'] .btn.vibrate-icon {
  display: none;
}

.dialog-header {
  font-size: 2.2rem;
  font-weight: 600;
  background: linear-gradient(135deg, var(--text-primary) 0%, var(--light-blue) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 8px var(--shadow-dark);
  margin-bottom: 1rem;
}

.tutorial-container {
  max-width: 600px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 16px;
  backdrop-filter: blur(15px);
  border: 1px solid var(--border-color);
  box-shadow: 0 12px 40px var(--shadow-dark);
  position: relative;
}

.tutorial-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(50, 130, 184, 0.03) 0%, rgba(241, 143, 1, 0.03) 100%);
  border-radius: 16px;
  pointer-events: none;
}

.tutorial-go-back-btn {
  margin-top: 2rem;
  padding: 8px 16px;
  font-size: 1.2rem;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  transition: all 0.3s ease;
  min-width: 120px;
}

.tutorial-go-back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px var(--shadow-light);
}

.tutorial-go-back-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px var(--shadow-light);
}

/* Mobile First Responsive Design */
@media (max-width: 480px) {
  :root {
  --base-node-size: 22px;
  }
  
  body {
    font-size: 1.4rem;
  }
  
  .home-page__title {
    font-size: 3.5rem;
  }
  
  .loading-title h2 {
    font-size: 3rem;
  }
  
  .btn {
    padding: 10px 20px;
    font-size: 1.3rem;
  }
  
  .icon_container {
    width: 2rem;
    height: 2rem;
  }
  
  .board {
    padding: 6px;
    width: fit-content;
    max-width: 100%;
    overflow: hidden;
    grid-template-columns: 22px 220px;
    grid-template-rows: 22px 220px;
  }
  
  .bot-player-board {
    grid-template-columns: 220px 22px;
    grid-template-rows: 22px 220px;
  }
  
  .board-item-container {
    grid-template-columns: repeat(10, 22px);
    grid-template-rows: repeat(10, 22px);
    width: 220px;
    height: 220px;
  }
  
  .row-label {
    grid-template-columns: repeat(10, 22px);
    width: 220px;
    font-size: 0.8rem;
  }
  
  .col-label {
    grid-template-rows: repeat(10, 22px);
    height: 220px;
    font-size: 0.8rem;
  }
  
  .label-item {
    width: 22px;
    height: 22px;
    font-size: 0.7rem;
    font-weight: 500;
  }
  
  .board-item {
    width: 22px !important;
    height: 22px !important;
    min-width: 22px !important;
    min-height: 22px !important;
    max-width: 22px !important;
    max-height: 22px !important;
  }
  
  .board-item-container {
    padding: 6px;
    gap: 1px;
  }
  
  .water-header {
    font-size: 2rem;
  }
  
  .players-desc-container {
    padding: 8px 16px;
    gap: 1rem;
  }
  
  .players-desc-container p {
    font-size: 1.6rem;
  }
  
  .ship-yard {
    padding: 16px;
  }
  
  .tutorial-container {
    padding: 16px;
    margin: 16px;
  }
  
  .dialog-header {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .game-play-container .container {
    padding: 0.3rem;
    gap: 0.3rem;
    height: 100vh;
    max-height: 100vh;
    flex: 1;
  }
  
  .human-player-section-container,
  .bot-player-section-container {
    max-width: 100%;
  }
  
  .game-dashboard-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 12px;
  }
  
  .vertical-divider-container {
    display: none !important;
  }
  
  .small-screen_divider {
    display: grid !important;
  }
  
  .board {
    margin: 0 auto;
    max-width: 100%;
    width: fit-content;
    padding: 8px;
    grid-template-columns: var(--base-node-size) calc(var(--base-node-size) * 10);
    grid-template-rows: var(--base-node-size) calc(var(--base-node-size) * 10);
  }
  
  .bot-player-board {
    grid-template-columns: calc(var(--base-node-size) * 10) var(--base-node-size);
    grid-template-rows: var(--base-node-size) calc(var(--base-node-size) * 10);
  }
  
  .board-item-container {
    grid-template-columns: repeat(10, var(--base-node-size));
    grid-template-rows: repeat(10, var(--base-node-size));
    gap: 0;
    width: calc(var(--base-node-size) * 10);
    height: calc(var(--base-node-size) * 10);
  }
  
  .row-label {
    grid-template-columns: repeat(10, var(--base-node-size));
    font-size: 1rem;
  }
  
  .col-label {
    grid-template-rows: repeat(10, var(--base-node-size));
    font-size: 1rem;
  }
  
  .label-item {
    width: var(--base-node-size);
    height: var(--base-node-size);
    font-size: 0.9rem;
  }
  
  .ship-yard {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (min-width: 768px) {
  .settings-form .horizontal-divider-container .horizontal-divider {
    display: block;
  }

  .settings-form .horizontal-divider:nth-of-type(1) {
    width: 35%;
  }

  .settings-form .horizontal-divider:nth-of-type(2) {
    width: 35%;
  }

  .settings-form h2 {
    width: 30%;
  }

  .settings-modal h2 {
    width: 100%;
  }

  .container {
    width: 85%;
  }
  
  .hidden_small {
    display: block;
  }
}

@media (min-width: 900px) {
  html {
    font-size: 12px;
  }

  dialog {
    width: 60%;
    max-width: 600px;
  }

  :root {
    --base-node-size: 22px;
  }

  .container {
    width: 85%;
    max-width: 1200px;
  }

  .hidden_mid {
    display: none;
  }

  .icon_container {
    width: 35px;
    height: 35px;
  }

  .row-label,
  .col-label {
    font-size: 2rem;
  }

  .btn-group {
    padding: 12px 24px;
    font-size: 2rem;
  }

  .game-setup .container {
    flex-direction: row;
    gap: 3rem;
    align-items: flex-start;
  }

  .game-play-container {
    height: 100vh;
    overflow: hidden;
  }

  .game-play-container .container {
    flex-direction: row;
    gap: 2rem;
    align-items: flex-start;
    padding: 1rem;
    min-height: calc(100vh - 2rem);
  }

  .game-play-container .vertical-divider-container {
    display: grid;
    min-width: 50px;
  }

  .human-player-section-container {
    order: initial;
    flex: 1;
  }
  
  .bot-player-section-container {
    flex: 1;
  }

  .bot-ship-yard-container {
    max-width: 350px;
    min-width: 280px;
  }

  .bot-ship-yard-container .ship-node {
    width: 20px;
    height: 20px;
  }
  
  .board {
    margin: 0;
  }
  
  .ship-yard {
    max-width: 350px;
  }
  
  .home-page__title {
    font-size: 5rem;
  }
  
  .water-header {
    font-size: 2.5rem;
  }
}

@media (min-width: 1200px) {
  :root {
    --base-node-size: 32px;
  }
  
  .container {
    width: 90%;
    max-width: 1400px;
  }
  
  .game-play-container .container {
    gap: 3rem;
    padding: 2rem 1rem;
  }
  
  .board {
    padding: 20px;
  }
  
  .ship-yard {
    padding: 24px;
    max-width: 400px;
  }
  
  .bot-ship-yard-container {
    min-width: 320px;
  }
}

/* ===============================================
   DASHBOARD STYLES
   =============================================== */

.dashboard-container {
  min-height: 100vh;
  background: linear-gradient(135deg, var(--primary-bg) 0%, var(--secondary-bg) 100%);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  animation: fadeIn 0.6s ease-out;
}

.dashboard-header {
  text-align: center;
  margin-bottom: 1rem;
}

.dashboard-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.username-highlight {
  color: var(--accent-color);
  background: linear-gradient(45deg, var(--accent-color), var(--secondary-accent));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
}

.dashboard-subtitle {
  font-size: 1.2rem;
  color: var(--text-secondary);
  margin: 0;
  opacity: 0.9;
}

.section-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--text-color);
  margin: 0 0 1.5rem 0;
  text-align: center;
}

/* Game Modes Section */
.game-modes-section {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.game-modes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
}

.game-mode-card {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.game-mode-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--accent-color), var(--secondary-accent));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.game-mode-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 255, 255, 0.2);
}

.game-mode-card:hover::before {
  opacity: 1;
}

.card-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 1rem auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(45deg, var(--accent-color), var(--secondary-accent));
  border-radius: 50%;
  color: white;
}

.card-icon svg {
  width: 30px;
  height: 30px;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-color);
  margin: 0 0 0.5rem 0;
  text-align: center;
}

.card-description {
  color: var(--text-secondary);
  text-align: center;
  margin: 0 0 1rem 0;
  line-height: 1.5;
}

.difficulty-options {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.difficulty-tag {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.difficulty-tag.easy {
  background: linear-gradient(45deg, #4ade80, #22c55e);
  color: white;
}

.difficulty-tag.hard {
  background: linear-gradient(45deg, #f87171, #ef4444);
  color: white;
}

.online-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
}

.online-indicator {
  width: 8px;
  height: 8px;
  background: #22c55e;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.online-count {
  color: var(--text-secondary);
  font-size: 0.875rem;
}

.tutorial-badge {
  text-align: center;
  margin-top: 1rem;
}

.tutorial-badge span {
  background: linear-gradient(45deg, var(--accent-color), var(--secondary-accent));
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Online Players Section */
.online-players-section {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.players-container {
  max-width: 800px;
  margin: 0 auto;
}

.players-count {
  text-align: center;
  color: var(--text-secondary);
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.players-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  min-height: 100px;
}

/* Empty Players Message Styling */
.empty-players-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
  min-height: 120px;
  grid-column: 1 / -1; /* Take full width in grid */
}

.empty-players-message .empty-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  opacity: 0.6;
}

.empty-players-message .empty-text {
  color: var(--text-primary);
  font-size: 1rem;
  font-weight: 500;
  margin: 0 0 0.5rem 0;
}

.empty-players-message .empty-subtext {
  color: var(--text-secondary);
  font-size: 0.85rem;
  margin: 0;
  font-style: italic;
}

.player-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.player-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.player-avatar {
  width: 40px;
  height: 40px;
  background: linear-gradient(45deg, var(--accent-color), var(--secondary-accent));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
}

.player-info {
  flex: 1;
}

.player-name {
  color: var(--text-color);
  font-weight: 500;
  margin: 0 0 0.25rem 0;
}

.player-status {
  color: var(--text-secondary);
  font-size: 0.875rem;
  margin: 0;
}

/* User Actions Section */
.user-actions-section {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.logout-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--text-color);
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  backdrop-filter: blur(10px);
}

.logout-btn svg {
  width: 20px;
  height: 20px;
}

.logout-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.3);
  transform: translateY(-2px);
}



/* AI Difficulty Modal */
.ai-difficulty-modal {
  border: none;
  border-radius: 20px;
  padding: 0;
  background: linear-gradient(145deg, var(--primary-bg), var(--secondary-bg));
  backdrop-filter: blur(20px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 600px;
  width: 90vw;
}

.ai-difficulty-modal::backdrop {
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
}

.modal-content {
  padding: 2rem;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.modal-title {
  color: var(--text-color);
  margin: 0;
  font-size: 1.8rem;
  font-weight: 600;
}

.modal-close-btn {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.modal-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--text-color);
}

.modal-close-btn svg {
  width: 24px;
  height: 24px;
}

.difficulty-options-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.difficulty-option {
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.difficulty-option:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-4px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.difficulty-option.easy-option:hover {
  border-color: #22c55e;
  box-shadow: 0 10px 30px rgba(34, 197, 94, 0.2);
}

.difficulty-option.hard-option:hover {
  border-color: #ef4444;
  box-shadow: 0 10px 30px rgba(239, 68, 68, 0.2);
}

.difficulty-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 1rem auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.easy-option .difficulty-icon {
  background: linear-gradient(45deg, #4ade80, #22c55e);
  color: white;
}

.hard-option .difficulty-icon {
  background: linear-gradient(45deg, #f87171, #ef4444);
  color: white;
}

.difficulty-icon svg {
  width: 30px;
  height: 30px;
}

.difficulty-option h3 {
  color: var(--text-color);
  margin: 0 0 0.5rem 0;
  font-size: 1.4rem;
  font-weight: 600;
}

.difficulty-option p {
  color: var(--text-secondary);
  margin: 0 0 1rem 0;
  line-height: 1.5;
}

.difficulty-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.difficulty-features li {
  color: var(--text-secondary);
  padding: 0.25rem 0;
  font-size: 0.9rem;
}

.difficulty-features li::before {
  content: '✓';
  color: var(--accent-color);
  font-weight: bold;
  margin-right: 0.5rem;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--text-color);
  padding: 0.75rem 2rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  font-weight: 500;
}

.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

/* Dashboard Responsive Design */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 1rem;
    gap: 1.5rem;
  }
  
  .dashboard-title {
    font-size: 2rem;
  }
  
  .dashboard-subtitle {
    font-size: 1rem;
  }
  
  .game-modes-section,
  .online-players-section {
    padding: 1.5rem;
  }
  
  .game-modes-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .game-mode-card {
    padding: 1.5rem;
  }
  
  .players-list {
    grid-template-columns: 1fr;
  }
  
  .user-actions-section {
    flex-direction: column;
    align-items: center;
  }
  
  .logout-btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
  
  .modal-content {
    padding: 1.5rem;
  }
  
  .difficulty-options-container {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .difficulty-option {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .dashboard-title {
    font-size: 1.8rem;
  }
  
  .game-mode-card {
    padding: 1rem;
  }
  
  .card-icon {
    width: 50px;
    height: 50px;
  }
  
  .card-icon svg {
    width: 24px;
    height: 24px;
  }
  
  .ai-difficulty-modal {
    width: 95vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;;EAEtB,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;;EAEvB,cAAc;EACd,+DAA+D;EAC/D,iEAAiE;EACjE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;EACxC,uCAAuC;EACvC,oCAAoC;;EAEpC,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;;EAEpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,yGAAyG;EACzG,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;EAC1B,0EAA0E;EAC1E,2BAA2B;EAC3B,8DAA8D;EAC9D,yBAAyB;AAC3B;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uFAAuF;EACvF,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,iDAAiD;EACjD,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qFAAqF;AACvF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;;AAEnB;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,8GAA8G;EAC9G,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;kFAEgF;EAChF,kDAAkD;AACpD;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;EACpC,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sGAAsG;EACtG;4CAC0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,iDAAiD;AACnD;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,6EAA6E;EAC7E,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf;6BAC2B;EAC3B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA,wBAAwB;;AAExB,cAAc;AACd;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;mFAEiF;EACjF,sDAAsD;AACxD;;AAEA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,yCAAyC,EAAE;AACnD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qGAAqG;EACrG,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,WAAW,qBAAqB,EAAE;EAClC,MAAM,uBAAuB,EAAE;AACjC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa,EAAE,8CAA8C;AAC/D;;AAEA,kEAAkE;AAClE;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;AACA,mBAAmB;;AAEnB,oBAAoB;AACpB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;mFAEiF;EACjF,uDAAuD;AACzD;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,MAAM,6CAA6C,EAAE;AACvD;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,6CAA6C;EAC7C;;2BAEyB;EACzB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,qCAAqC;EACrC,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;EAChD;;2BAEyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,wDAAwD;EACxD,qDAAqD;EACrD;;;;;;;;;;iEAU+D;AACjE;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,wDAAwD;EACxD,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,qCAAqC;EACrC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8FAA8F;EAC9F,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;;AAEzB,yBAAyB;;AAEzB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kCAAkC;EAClC,gBAAgB;EAChB,QAAQ;EACR,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mFAAmF;EACnF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yCAAyC;EACzC,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,WAAW,qBAAqB,EAAE;EAClC,MAAM,wBAAwB,EAAE;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0GAA0G;EAC1G,kBAAkB;EAClB,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,2GAA2G;EAC3G,kBAAkB;EAClB,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,uEAAuE;EACvE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;;EAEE,qEAAqE;EACrE,6BAA6B;EAC7B,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;;EAEE,uEAAuE;EACvE,+BAA+B;EAC/B,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,qEAAqE;IACrE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,4CAA4C;EAC9C;EACA;IACE,mBAAmB;IACnB,6CAA6C;EAC/C;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+FAA+F;EAC/F,qCAAqC;EACrC,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,sEAAsE;EACtE,8BAA8B;EAC9B,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,gCAAgC;IAChC,iCAAiC;IACjC,gCAAgC;IAChC,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,+DAA+D;IAC/D,iEAAiE;IACjE,uBAAuB;IACvB,yBAAyB;IACzB,wCAAwC;EAC1C;AACF;;AAEA,wBAAwB;;AAExB,+BAA+B;AAC/B;;;EAGE,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uFAAuF;EACvF,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;EAC7C,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;EACE,KAAK,sBAAsB,EAAE,UAAU,EAAE;EACzC,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,oEAAoE;EACpE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;EACpE,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE;;;;;;IAME,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;kFAEgF;EAChF,2DAA2D;AAC7D;;AAEA;EACE,WAAW,gCAAgC,EAAE;EAC7C,MAAM,mCAAmC,EAAE;AAC7C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mFAAmF;EACnF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mFAAmF;EACnF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8FAA8F;EAC9F,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA,mCAAmC;AACnC;EACE;EACA,sBAAsB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA;IACE,uCAAuC;IACvC,oCAAoC;IACpC,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,uCAAuC;IACvC,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,OAAO;EACT;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,6EAA6E;IAC7E,0EAA0E;EAC5E;;EAEA;IACE,6EAA6E;IAC7E,0EAA0E;EAC5E;;EAEA;IACE,wDAAwD;IACxD,qDAAqD;IACrD,MAAM;IACN,uCAAuC;IACvC,wCAAwC;EAC1C;;EAEA;IACE,wDAAwD;IACxD,eAAe;EACjB;;EAEA;IACE,qDAAqD;IACrD,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;oDAEoD;;AAEpD;EACE,iBAAiB;EACjB,mFAAmF;EACnF,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,gFAAgF;EAChF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wFAAwF;EACxF,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gFAAgF;EAChF,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gFAAgF;EAChF,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gFAAgF;EAChF,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gFAAgF;EAChF,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;AAC7B;;;;AAIA,wBAAwB;AACxB;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,2EAA2E;EAC3E,2BAA2B;EAC3B,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["*,\n*::after,\n*::before {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  box-sizing: inherit;\n  height: 100%;\n  font-size: 10px;\n}\n\n:root {\n  --base-node-size: 20px;\n  \n  /* Modern Color Palette */\n  --primary-blue: #0F4C75;\n  --secondary-blue: #3282B8;\n  --accent-blue: #0F4C75;\n  --light-blue: #BBE1FA;\n  --dark-navy: #1B2951;\n  --ocean-blue: #2E86AB;\n  --sea-foam: #A23B72;\n  --coral: #F18F01;\n  --deep-water: #0A2342;\n  --surface-blue: #205295;\n  \n  /* UI Colors */\n  --bg-primary: linear-gradient(135deg, #0F4C75 0%, #3282B8 100%);\n  --bg-secondary: linear-gradient(135deg, #1B2951 0%, #0F4C75 100%);\n  --bg-dark: #0A2342;\n  --text-primary: #FFFFFF;\n  --text-secondary: #BBE1FA;\n  --border-color: rgba(187, 225, 250, 0.3);\n  --shadow-light: rgba(50, 130, 184, 0.2);\n  --shadow-dark: rgba(10, 35, 66, 0.4);\n  \n  /* Ship Colors */\n  --ship-color: #F18F01;\n  --ship-hit: #E74C3C;\n  --ship-sunk: #C0392B;\n  --water-miss: #7FB3D3;\n  --water-hit: #E74C3C;\n  \n  /* Success/Error */\n  --success: #27AE60;\n  --warning: #F39C12;\n  --error: #E74C3C;\n}\n\nbody {\n  font-size: 1.6rem;\n  line-height: 1.5;\n  letter-spacing: 0.5px;\n  height: 100vh;\n  min-height: 100vh;\n  text-transform: lowercase;\n  font-family: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-weight: 400;\n  overflow-x: hidden;\n}\n\ndialog {\n  margin: auto;\n  border: none;\n  border-radius: 16px;\n  min-width: 280px;\n  min-height: 200px;\n  width: 85%;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  box-shadow: 0 20px 60px var(--shadow-dark), 0 8px 25px var(--shadow-light);\n  backdrop-filter: blur(10px);\n  animation: modalSlideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  transition: all 0.3s ease;\n}\n\n@keyframes modalSlideIn {\n  from {\n    transform: scale(0.8) translateY(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n}\n\ndialog::backdrop {\n  background: rgba(10, 35, 66, 0.7);\n  backdrop-filter: blur(4px);\n  animation: backdropFadeIn 0.3s ease;\n}\n\n@keyframes backdropFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\nbutton:active,\nbutton:focus {\n  outline: none;\n}\n\n/* Global transitions */\n* {\n  transition: all 0.2s ease;\n}\n\n*:focus-visible {\n  outline: 2px solid var(--accent-blue);\n  outline-offset: 2px;\n}\n\nul {\n  list-style: none;\n}\n\n.z_index_1 {\n  z-index: 1;\n}\n\n.z_index_2 {\n  z-index: 2;\n}\n\n.z_index_3 {\n  z-index: 3;\n}\n\n.hidden {\n  display: none;\n}\n\n.icon_container {\n  width: 2.5rem;\n  height: 2.5rem;\n  padding: 8px;\n  box-sizing: initial;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  transition: all 0.3s ease;\n}\n\n.icon_container:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.1);\n  box-shadow: 0 4px 15px var(--shadow-light);\n}\n\n.cursor_pointer {\n  cursor: pointer;\n}\n\n.cursor_crosshair {\n  cursor: crosshair;\n}\n\n.img,\nimg {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  max-height: 100%;\n}\n\n.text-align__center {\n  text-align: center;\n}\n\n.text-align__center1 {\n  text-align: center;\n  display: block;\n  width: 100%;\n}\n\n.text-transform__uppercase {\n  text-transform: uppercase;\n}\n\n.text-transform__capitalize {\n  text-transform: capitalize;\n}\n\n.text-transform__lowercase {\n  text-transform: lowercase;\n}\n\n.container {\n  width: 100%;\n  max-width: 1128px;\n  position: relative;\n}\n\n.d-flex__row {\n  display: flex;\n  flex-direction: row;\n}\n\n.d-flex__col {\n  display: flex;\n  flex-direction: column;\n}\n\n.flex-direction__col {\n  flex-direction: column;\n}\n\n.flex-direction__row {\n  flex-direction: row;\n}\n\n.justify-content__center {\n  justify-content: center;\n}\n\n.justify-content__space-around {\n  justify-content: space-around;\n}\n.justify-content__space-between {\n  justify-content: space-between;\n}\n\n.align-items__center {\n  align-items: center;\n}\n\n.centered_flex {\n  justify-content: center;\n  align-items: center;\n}\n\n.gap_10 {\n  gap: 10px;\n}\n\n.gap_5 {\n  gap: 5px;\n}\n\n.gap_2 {\n  gap: 2px;\n}\n\n.gap_1r {\n  gap: 1rem;\n}\n\n.gap_2r {\n  gap: 2rem;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.padding-top_10 {\n  padding-top: 10px;\n}\n\n.padding-bottom_10 {\n  padding-bottom: 10px;\n}\n\n.padding-left_10 {\n  padding-left: 10px;\n}\n\n.padding-right_10 {\n  padding-right: 10px;\n}\n\n.padding_10 {\n  padding: 10px;\n}\n\n.padding_2r {\n  padding: 2rem;\n}\n\n.btn {\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: linear-gradient(135deg, var(--secondary-blue) 0%, var(--primary-blue) 100%);\n  color: var(--text-primary);\n  font-family: inherit;\n  font-weight: 600;\n  border-radius: 12px;\n  padding: 12px 24px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(50, 130, 184, 0.3);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-size: 1.4rem;\n}\n\n.btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s ease;\n}\n\n.btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(50, 130, 184, 0.4);\n  background: linear-gradient(135deg, var(--ocean-blue) 0%, var(--secondary-blue) 100%);\n}\n\n.btn:hover::before {\n  left: 100%;\n}\n\n.btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 10px rgba(50, 130, 184, 0.3);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.fz_2-4r {\n  font-size: 2.4rem;\n}\n\n.fz_2r {\n  font-size: 2rem;\n}\n\n.fz_1-8r {\n  font-size: 1.8rem;\n}\n\n.fz_1-4r {\n  font-size: 1.4rem;\n}\n\n/* LOADING SCREEN */\n\n.loading-title {\n  text-align: center;\n  animation: titleFadeIn 1s ease-out;\n}\n\n.loading-title h1 {\n  font-size: 1.8rem;\n  letter-spacing: 3px;\n  font-weight: 300;\n  color: var(--text-secondary);\n  margin-bottom: 0.5rem;\n  animation: slideInFromTop 0.8s ease-out;\n}\n\n.loading-title h2 {\n  font-size: 4rem;\n  letter-spacing: 2px;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--text-primary) 0%, var(--light-blue) 50%, var(--secondary-blue) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: slideInFromBottom 0.8s ease-out 0.2s both;\n}\n\n.loading-screen {\n  height: 100%;\n  text-align: center;\n  background: var(--bg-primary);\n  position: relative;\n  overflow: hidden;\n}\n\n.loading-screen::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 80%, rgba(50, 130, 184, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(15, 76, 117, 0.1) 0%, transparent 50%);\n  animation: backgroundPulse 4s ease-in-out infinite;\n}\n\n@keyframes backgroundPulse {\n  0%, 100% { opacity: 0.3; }\n  50% { opacity: 0.7; }\n}\n\n@keyframes titleFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes slideInFromTop {\n  from {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInFromBottom {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.loading-bar {\n  height: auto;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n.loading-line {\n  height: calc(var(--base-node-size) + 4px);\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 25px;\n  border: 2px solid var(--border-color);\n  overflow: hidden;\n  position: relative;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 20px var(--shadow-dark);\n}\n\n.line {\n  height: 100%;\n  border-radius: 25px;\n  background: linear-gradient(90deg, var(--secondary-blue) 0%, var(--coral) 50%, var(--ocean-blue) 100%);\n  animation: loading 2.5s cubic-bezier(0.4, 0, 0.2, 1) 200ms forwards,\n             shimmer 2s ease-in-out infinite;\n  position: relative;\n  overflow: hidden;\n}\n\n.line::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  animation: slideShimmer 1.5s ease-in-out infinite;\n}\n\n@keyframes slideShimmer {\n  0% { left: -100%; }\n  100% { left: 100%; }\n}\n\n.loading-screen.loading-complete .line {\n  background: linear-gradient(90deg, var(--success) 0%, var(--ocean-blue) 100%);\n  box-shadow: 0 0 20px rgba(39, 174, 96, 0.5);\n}\n\n.loading-screen.loading-complete .loading-line {\n  border-color: var(--success);\n  box-shadow: 0 4px 20px rgba(39, 174, 96, 0.3);\n}\n\n@keyframes loading {\n  0% {\n    width: 0%;\n    transform: scaleX(0);\n  }\n  100% {\n    width: 100%;\n    transform: scaleX(1);\n  }\n}\n\n@keyframes shimmer {\n  0%, 100% {\n    filter: brightness(1);\n  }\n  50% {\n    filter: brightness(1.2);\n  }\n}\n\n.loading-text {\n  font-size: 1.6rem;\n  letter-spacing: 1.5px;\n  color: var(--text-secondary);\n  animation: textPulse 2s ease-in-out infinite;\n}\n\n@keyframes textPulse {\n  0%, 100% { opacity: 0.7; }\n  50% { opacity: 1; }\n}\n\n.loader {\n  display: inline-block;\n  margin-left: 8px;\n  width: 28px;\n  aspect-ratio: 4;\n  background: radial-gradient(circle closest-side, var(--secondary-blue) 90%, transparent) 0 /\n    calc(100% / 3) 100% space;\n  clip-path: inset(0 100% 0 0);\n  animation: l1 1.5s steps(4) infinite;\n}\n\n@keyframes l1 {\n  to {\n    clip-path: inset(0 -34% 0 0);\n  }\n}\n\n/* LOADING SCREEN ENDS */\n\n/* HOME PAGE */\n.home-page {\n  height: 100%;\n  background: var(--bg-primary);\n  position: relative;\n  overflow: hidden;\n}\n\n.home-page::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 30% 20%, rgba(50, 130, 184, 0.15) 0%, transparent 50%),\n    radial-gradient(circle at 70% 80%, rgba(15, 76, 117, 0.15) 0%, transparent 50%);\n  animation: homeBackgroundFloat 6s ease-in-out infinite;\n}\n\n@keyframes homeBackgroundFloat {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  50% { transform: translateY(-10px) rotate(1deg); }\n}\n\n.home-page .container {\n  position: relative;\n  z-index: 1;\n  animation: containerSlideIn 0.8s ease-out;\n}\n\n@keyframes containerSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.home-page__title {\n  font-size: 4.5rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--text-primary) 0%, var(--light-blue) 50%, var(--coral) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: 0 4px 8px var(--shadow-dark);\n  animation: titleGlow 3s ease-in-out infinite;\n}\n\n@keyframes titleGlow {\n  0%, 100% { filter: brightness(1); }\n  50% { filter: brightness(1.2); }\n}\n\n.home-page__btn-group {\n  width: 60%;\n  max-width: 280px;\n  animation: buttonsSlideIn 0.8s ease-out 0.3s both;\n}\n\n@keyframes buttonsSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.home-page__btn-group .btn {\n  padding: 16px 32px;\n  font-size: 1.6rem;\n  font-weight: 600;\n  min-width: 140px;\n}\n\n.tutorial-btn-container {\n  position: absolute;\n  top: 30px;\n  left: 30px;\n  animation: tutorialFadeIn 1s ease-out 0.5s both;\n}\n\n@keyframes tutorialFadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.tutorial__btn {\n  padding: 16px 32px;\n  font-size: 1.6rem;\n  font-weight: 600;\n  min-width: 140px;\n  display: none; /* Hidden by default, shown on small screens */\n}\n\n/* Desktop: Show icon tutorial button, hide text tutorial button */\n@media (min-width: 768px) {\n  .tutorial-btn-container {\n    display: block;\n  }\n  \n  .tutorial__btn {\n    display: none;\n  }\n}\n\n/* Mobile/Tablet: Hide icon tutorial button, show text tutorial button */\n@media (max-width: 767px) {\n  .tutorial-btn-container {\n    display: none;\n  }\n  \n  .tutorial__btn {\n    display: block;\n  }\n}\n/* HOME PAGE ENDS */\n\n/* GAME SETUP PAGE */\n.game-setup {\n  min-height: 100vh;\n  text-align: center;\n  background: var(--bg-primary);\n  position: relative;\n  padding: 1rem 0;\n}\n\n.game-setup::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 15% 25%, rgba(50, 130, 184, 0.1) 0%, transparent 40%),\n    radial-gradient(circle at 85% 75%, rgba(241, 143, 1, 0.08) 0%, transparent 40%);\n  animation: setupBackgroundDrift 8s ease-in-out infinite;\n}\n\n@keyframes setupBackgroundDrift {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50% { transform: translate(-5px, -10px) scale(1.02); }\n}\n\n.game-setup .container {\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n  animation: setupContainerFadeIn 0.6s ease-out;\n}\n\n@keyframes setupContainerFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.board {\n  display: grid;\n  grid-template-columns: var(--base-node-size) 1fr;\n  grid-template-rows: var(--base-node-size) 1fr;\n  grid-template-areas:\n    '. row-label'\n    'col-label board-items';\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 12px;\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 8px 32px var(--shadow-dark);\n  transition: all 0.3s ease;\n  width: fit-content;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.board:hover {\n  box-shadow: 0 12px 40px var(--shadow-dark);\n  border-color: rgba(187, 225, 250, 0.5);\n}\n\n.bot-player-board {\n  grid-template-columns: 1fr var(--base-node-size);\n  grid-template-areas:\n    'row-label .'\n    'board-items col-label';\n}\n\n.board-item-container {\n  grid-area: board-items;\n  display: grid;\n  grid-template-columns: repeat(10, var(--base-node-size));\n  grid-template-rows: repeat(10, var(--base-node-size));\n  grid-template-areas:\n    'X0-Y0 X1-Y0 X2-Y0 X3-Y0 X4-Y0 X5-Y0 X6-Y0 X7-Y0 X8-Y0 X9-Y0'\n    'X0-Y1 X1-Y1 X2-Y1 X3-Y1 X4-Y1 X5-Y1 X6-Y1 X7-Y1 X8-Y1 X9-Y1'\n    'X0-Y2 X1-Y2 X2-Y2 X3-Y2 X4-Y2 X5-Y2 X6-Y2 X7-Y2 X8-Y2 X9-Y2'\n    'X0-Y3 X1-Y3 X2-Y3 X3-Y3 X4-Y3 X5-Y3 X6-Y3 X7-Y3 X8-Y3 X9-Y3'\n    'X0-Y4 X1-Y4 X2-Y4 X3-Y4 X4-Y4 X5-Y4 X6-Y4 X7-Y4 X8-Y4 X9-Y4'\n    'X0-Y5 X1-Y5 X2-Y5 X3-Y5 X4-Y5 X5-Y5 X6-Y5 X7-Y5 X8-Y5 X9-Y5'\n    'X0-Y6 X1-Y6 X2-Y6 X3-Y6 X4-Y6 X5-Y6 X6-Y6 X7-Y6 X8-Y6 X9-Y6'\n    'X0-Y7 X1-Y7 X2-Y7 X3-Y7 X4-Y7 X5-Y7 X6-Y7 X7-Y7 X8-Y7 X9-Y7'\n    'X0-Y8 X1-Y8 X2-Y8 X3-Y8 X4-Y8 X5-Y8 X6-Y8 X7-Y8 X8-Y8 X9-Y8'\n    'X0-Y9 X1-Y9 X2-Y9 X3-Y9 X4-Y9 X5-Y9 X6-Y9 X7-Y9 X8-Y9 X9-Y9';\n}\n\n.board-item.can-receive-ship {\n  background-color: rgba(0, 225, 0, 0.5);\n}\n\n.board-item.cannot-receive-ship {\n  background-color: rgba(225, 0, 0, 0.5);\n}\n\n.row-label {\n  grid-area: row-label;\n  display: grid;\n  grid-template-columns: repeat(10, var(--base-node-size));\n  font-size: 1.4rem;\n}\n\n.col-label {\n  grid-area: col-label;\n  display: grid;\n  grid-template-rows: repeat(10, var(--base-node-size));\n  font-size: 1.4rem;\n}\n\n.label-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--base-node-size);\n  height: var(--base-node-size);\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-color);\n  text-align: center;\n}\n\n.home-btn-container {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 1000;\n}\n\n.home-btn-container .btn {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 4px 20px var(--shadow-dark);\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.home-btn-container .btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px var(--shadow-dark);\n}\n\n.ship-yard {\n  display: flex;\n  margin-bottom: 2rem;\n  align-items: flex-start;\n  justify-content: space-around;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 24px;\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 8px 32px var(--shadow-dark);\n  position: relative;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ship-yard::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(50, 130, 184, 0.05) 0%, rgba(241, 143, 1, 0.05) 100%);\n  border-radius: 16px;\n  pointer-events: none;\n}\n\n.ship-node {\n  background-color: #6565f5;\n  width: var(--base-node-size);\n  height: var(--base-node-size);\n  border-radius: 3px;\n}\n\n.ship[data-orientation='HORIZONTAL'] {\n  flex-direction: row;\n}\n\n.ship[data-orientation='VERTICAL'] {\n  flex-direction: column;\n}\n\n.btn-group .btn {\n  padding: 10px 18px;\n  font-size: 1.5rem;\n  min-width: 120px;\n  box-shadow: 0 4px 15px rgba(50, 130, 184, 0.3);\n}\n\n.btn.rotate {\n  padding: 8px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 4px 15px var(--shadow-light);\n}\n\n.btn.rotate:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.1) rotate(90deg);\n  box-shadow: 0 6px 20px var(--shadow-light);\n}\n\n.ship.active .ship-node {\n  background-color: green;\n}\n\n.ship.place {\n  z-index: 2;\n}\n\n.ship.fail-place .ship-node {\n  background-color: red;\n}\n\n/* GAME SETUP PAGE ENDS */\n\n/* GAME PLAY PAGE START */\n\n.game-play-container {\n  text-align: center;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem 0;\n}\n\n.human-player-section-container {\n  display: grid;\n  gap: 1rem;\n  grid-template-rows: auto 10px auto;\n  max-width: 400px;\n  order: 2;\n  justify-items: center;\n  flex: 1;\n}\n\n.bot-player-section-container {\n  display: grid;\n  gap: 1rem;\n  grid-template-rows: auto 10px auto;\n  max-width: 400px;\n  justify-items: center;\n  flex: 1;\n}\n\n.bot-player-section-container .ship.sunk .ship-node {\n  background-color: red;\n}\n\n.water-header {\n  font-size: 2rem;\n  text-align: center;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  background: linear-gradient(135deg, var(--text-primary) 0%, var(--light-blue) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: 0 4px 8px var(--shadow-dark);\n  animation: headerGlow 4s ease-in-out infinite;\n  white-space: nowrap;\n}\n\n@keyframes headerGlow {\n  0%, 100% { filter: brightness(1); }\n  50% { filter: brightness(1.15); }\n}\n\n.ship-yard-section-header {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-shadow: 0 2px 4px var(--shadow-dark);\n  margin-bottom: 0.5rem;\n  flex-shrink: 0;\n}\n\n.horizontal-divider-container {\n  display: grid;\n  width: 100%;\n}\n\n.vertical-divider-container {\n  display: none;\n  height: 100%;\n  justify-items: center;\n  grid-template-rows: 1fr 40px 1fr;\n  gap: 2rem;\n}\n\n.game-dashboard-container .vertical-divider-container {\n  display: grid;\n  grid-template-rows: 1fr;\n}\n\n.small-screen_divider {\n  display: grid;\n  grid-template-columns: 1fr 40px 1fr;\n  justify-content: center;\n  align-items: center;\n  justify-items: center;\n}\n\n.horizontal-divider {\n  height: 3px;\n  width: 100%;\n  background: linear-gradient(90deg, var(--secondary-blue) 0%, var(--coral) 50%, var(--secondary-blue) 100%);\n  border-radius: 2px;\n  box-shadow: 0 0 10px rgba(50, 130, 184, 0.5);\n  animation: dividerPulse 3s ease-in-out infinite;\n}\n\n.vertical-divider {\n  width: 3px;\n  height: 100%;\n  background: linear-gradient(180deg, var(--secondary-blue) 0%, var(--coral) 50%, var(--secondary-blue) 100%);\n  border-radius: 2px;\n  box-shadow: 0 0 10px rgba(50, 130, 184, 0.5);\n  animation: dividerPulse 3s ease-in-out infinite;\n}\n\n@keyframes dividerPulse {\n  0%, 100% {\n    box-shadow: 0 0 10px rgba(50, 130, 184, 0.5);\n  }\n  50% {\n    box-shadow: 0 0 20px rgba(50, 130, 184, 0.7);\n  }\n}\n\n.turn-marker {\n  border: 2px solid green;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  align-self: center;\n}\n\n.game-dashboard-container {\n  display: grid;\n  gap: 1rem;\n  align-items: center;\n  justify-items: center;\n  grid-template-columns: 2fr 10px 1fr;\n}\n\n.players-desc-container {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.08);\n  padding: 12px 20px;\n  border-radius: 20px;\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 4px 20px var(--shadow-dark);\n}\n\n.players-desc-container p {\n  font-weight: 600;\n  font-size: 1.8rem;\n  color: var(--text-secondary);\n  text-shadow: 0 2px 4px var(--shadow-dark);\n}\n\n.board-item[data-has-ship='true'][data-mask='false'] {\n  background: linear-gradient(135deg, var(--ship-color) 0%, #E67E22 100%);\n  border-color: var(--ship-color);\n  box-shadow: 0 0 10px rgba(241, 143, 1, 0.4);\n}\n\n.board .board-item[data-hit-status='1'],\n.board .board-item[data-hit-status='2'] {\n  background: linear-gradient(135deg, var(--ship-hit) 0%, #C0392B 100%);\n  border-color: var(--ship-hit);\n  box-shadow: 0 0 15px rgba(231, 76, 60, 0.5);\n  animation: hitFlash 0.5s ease-out;\n}\n\n.board .board-item[data-hit-status='0'],\n.board .board-item[data-hit-status='3'] {\n  background: linear-gradient(135deg, var(--water-miss) 0%, #5DADE2 100%);\n  border-color: var(--water-miss);\n  box-shadow: 0 0 8px rgba(127, 179, 211, 0.3);\n  animation: missRipple 0.6s ease-out;\n}\n\n@keyframes hitFlash {\n  0% {\n    background: #FFFFFF;\n    transform: scale(1.2);\n  }\n  100% {\n    background: linear-gradient(135deg, var(--ship-hit) 0%, #C0392B 100%);\n    transform: scale(1);\n  }\n}\n\n@keyframes missRipple {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(127, 179, 211, 0.7);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(127, 179, 211, 0);\n  }\n}\n\n.game-controls {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.turn-marker[data-turn-indicator='human'] {\n  border-color: green;\n  background-color: green;\n}\n\n.turn-marker[data-turn-indicator='bot'] {\n  border-color: red;\n  background-color: red;\n}\n\n.bot-ship-yard-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n  padding: 1.2rem;\n  max-width: 280px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 8px 32px var(--shadow-dark);\n  justify-content: center;\n}\n\n.bot-ship-yard-container .ship-node {\n  width: 15px;\n  height: 15px;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  box-shadow: 0 2px 8px var(--shadow-light);\n  transition: all 0.3s ease;\n}\n\n.bot-ship-yard-container .ship.sunk .ship-node {\n  background: linear-gradient(135deg, var(--ship-sunk) 0%, #A93226 100%);\n  border-color: var(--ship-sunk);\n  box-shadow: 0 0 15px rgba(192, 57, 43, 0.5);\n  animation: sunkGlow 2s ease-in-out infinite;\n}\n\n@keyframes sunkGlow {\n  0%, 100% {\n    box-shadow: 0 0 15px rgba(192, 57, 43, 0.5);\n  }\n  50% {\n    box-shadow: 0 0 25px rgba(192, 57, 43, 0.7);\n  }\n}\n\n.hidden_small {\n  display: none;\n}\n\n/* Touch device optimizations */\n@media (hover: none) and (pointer: coarse) {\n  .btn {\n    min-height: 44px;\n    min-width: 44px;\n    font-size: 1.6rem;\n  }\n  \n  .board-item {\n    width: var(--base-node-size);\n    height: var(--base-node-size);\n    min-width: var(--base-node-size);\n    min-height: var(--base-node-size);\n    max-width: var(--base-node-size);\n    max-height: var(--base-node-size);\n    box-sizing: border-box;\n  }\n  \n  .icon_container {\n    min-height: 44px;\n    min-width: 44px;\n  }\n  \n  .ship-node {\n    min-height: 24px;\n    min-width: 24px;\n  }\n}\n\n/* High DPI displays */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .board {\n    border-width: 0.5px;\n  }\n  \n  .board-item {\n    border-width: 0.5px;\n  }\n  \n  .ship-node {\n    border-width: 1px;\n  }\n}\n\n/* Landscape mobile orientation */\n@media (max-height: 500px) and (orientation: landscape) {\n  .game-play-container {\n    padding: 0.5rem;\n  }\n  \n  .water-header {\n    font-size: 1.8rem;\n    margin-bottom: 0.5rem;\n  }\n  \n  .players-desc-container {\n    padding: 6px 12px;\n  }\n  \n  .game-dashboard-container {\n    padding: 8px;\n  }\n  \n  .ship-yard {\n    padding: 12px;\n  }\n}\n\n/* Reduced motion preference */\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  :root {\n    --bg-primary: linear-gradient(135deg, #0A1929 0%, #1B2951 100%);\n    --bg-secondary: linear-gradient(135deg, #0F1B2A 0%, #0A2342 100%);\n    --text-primary: #FFFFFF;\n    --text-secondary: #B0BEC5;\n    --border-color: rgba(176, 190, 197, 0.2);\n  }\n}\n\n/* GAME PLAY PAGE ENDS */\n\n/* Accessibility improvements */\n.btn:focus-visible,\n.board-item:focus-visible,\n.icon_container:focus-visible {\n  outline: 3px solid var(--accent-blue);\n  outline-offset: 2px;\n  z-index: 10;\n}\n\n/* Screen reader only content */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* User Registration Styles */\n.user-registration-dialog {\n  min-width: 400px;\n  max-width: 500px;\n  width: 90%;\n}\n\n.registration-header {\n  margin-bottom: 1rem;\n}\n\n.registration-icon {\n  width: 4rem;\n  height: 4rem;\n  background: linear-gradient(135deg, var(--secondary-blue) 0%, var(--primary-blue) 100%);\n  border-radius: 50%;\n  padding: 1rem;\n}\n\n.registration-subtitle {\n  color: var(--text-secondary);\n  font-size: 1.4rem;\n  margin: 0;\n}\n\n.username-input {\n  background: rgba(255, 255, 255, 0.1);\n  border: 2px solid var(--border-color);\n  color: var(--text-primary);\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 1.6rem;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.username-input:focus {\n  border-color: var(--secondary-blue);\n  box-shadow: 0 0 0 3px rgba(50, 130, 184, 0.2);\n  outline: none;\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.username-input::placeholder {\n  color: rgba(187, 225, 250, 0.6);\n}\n\n.username-help {\n  color: var(--text-secondary);\n  font-size: 1.2rem;\n  margin: 0;\n  opacity: 0.8;\n}\n\n.error-message {\n  background: rgba(231, 76, 60, 0.1);\n  border: 1px solid var(--error);\n  color: var(--error);\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 1.3rem;\n  margin: 0;\n  animation: errorShake 0.5s ease-in-out;\n}\n\n.success-message {\n  background: rgba(39, 174, 96, 0.1);\n  border: 1px solid var(--success);\n  color: var(--success);\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 1.3rem;\n  margin: 0;\n  animation: successPulse 0.5s ease-in-out;\n}\n\n@keyframes errorShake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-5px); }\n  75% { transform: translateX(5px); }\n}\n\n@keyframes successPulse {\n  0% { transform: scale(0.95); opacity: 0; }\n  50% { transform: scale(1.02); }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n.join-btn {\n  background: linear-gradient(135deg, var(--success) 0%, #27AE60 100%);\n  min-width: 120px;\n  font-weight: 600;\n}\n\n.join-btn:hover {\n  background: linear-gradient(135deg, #27AE60 0%, var(--success) 100%);\n  box-shadow: 0 8px 25px rgba(39, 174, 96, 0.4);\n}\n\n.join-btn:disabled {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.5);\n  cursor: not-allowed;\n  transform: none;\n}\n\n.cancel-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 2px solid var(--border-color);\n  color: var(--text-secondary);\n  min-width: 120px;\n}\n\n.cancel-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: var(--error);\n  color: var(--error);\n}\n\n.online-users-section {\n  border-top: 1px solid var(--border-color);\n  padding-top: 1.5rem;\n  margin-top: 1rem;\n}\n\n.online-users-header {\n  color: var(--text-secondary);\n  font-size: 1.4rem;\n  margin: 0;\n  font-weight: 600;\n}\n\n.online-users-list {\n  min-height: 40px;\n  max-height: 100px;\n  overflow-y: auto;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--border-color);\n  padding: 8px;\n}\n\n.online-user-tag {\n  background: rgba(50, 130, 184, 0.2);\n  color: var(--text-primary);\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 1.2rem;\n  border: 1px solid rgba(50, 130, 184, 0.3);\n  white-space: nowrap;\n  animation: userTagFadeIn 0.3s ease-out;\n}\n\n@keyframes userTagFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.online-users-empty {\n  color: var(--text-secondary);\n  font-style: italic;\n  opacity: 0.7;\n  font-size: 1.2rem;\n}\n\n/* Connection status indicator */\n.connection-status {\n  position: fixed;\n  top: 70px;\n  right: 20px;\n  z-index: 1001;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 1.2rem;\n  font-weight: 600;\n  text-transform: lowercase;\n  backdrop-filter: blur(10px);\n  border: 1px solid;\n  transition: all 0.3s ease;\n}\n\n.connection-status.connected {\n  background: rgba(39, 174, 96, 0.1);\n  border-color: var(--success);\n  color: var(--success);\n}\n\n.connection-status.disconnected {\n  background: rgba(231, 76, 60, 0.1);\n  border-color: var(--error);\n  color: var(--error);\n}\n\n.connection-status.connecting {\n  background: rgba(241, 143, 1, 0.1);\n  border-color: var(--warning);\n  color: var(--warning);\n}\n\n/* Print styles */\n@media print {\n  .btn,\n  .icon_container,\n  .tutorial-btn-container,\n  .home-btn-container,\n  .user-registration-dialog,\n  .connection-status {\n    display: none;\n  }\n  \n  .board {\n    border: 2px solid #000;\n  }\n  \n  .board-item {\n    border: 1px solid #000;\n    background: #fff !important;\n  }\n  \n  .board-item[data-has-ship='true'] {\n    background: #ccc !important;\n  }\n}\n\n.settings-page {\n  min-height: 100%;\n  background: var(--bg-primary);\n  position: relative;\n}\n\n.settings-page::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 25% 25%, rgba(50, 130, 184, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 75% 75%, rgba(15, 76, 117, 0.1) 0%, transparent 50%);\n  animation: settingsBackgroundFloat 10s ease-in-out infinite;\n}\n\n@keyframes settingsBackgroundFloat {\n  0%, 100% { transform: scale(1) rotate(0deg); }\n  50% { transform: scale(1.05) rotate(1deg); }\n}\n\n.settings-page .container {\n  min-height: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n.settings-page h1 {\n  font-size: 3rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--text-primary) 0%, var(--light-blue) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: 0 4px 8px var(--shadow-dark);\n}\n\n.settings-page h2 {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-shadow: 0 2px 4px var(--shadow-dark);\n}\n\n.settings-form .horizontal-divider-container {\n  display: flex;\n}\n\n.settings-form .horizontal-divider-container .horizontal-divider {\n  display: none;\n}\n\n.music-controls-container,\n.vibration-controls-container {\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.volume-controls-container[data-volume='yes'] .btn.volume-mute-icon {\n  display: none;\n}\n\n.volume-controls-container[data-volume='no'] .btn.volume-high-icon {\n  display: none;\n}\n\n.vibrate-controls-container[data-vibrate='yes'] .btn.vibrate-off-icon {\n  display: none;\n}\n\n.vibrate-controls-container[data-vibrate='no'] .btn.vibrate-icon {\n  display: none;\n}\n\n.dialog-header {\n  font-size: 2.2rem;\n  font-weight: 600;\n  background: linear-gradient(135deg, var(--text-primary) 0%, var(--light-blue) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: 0 4px 8px var(--shadow-dark);\n  margin-bottom: 1rem;\n}\n\n.tutorial-container {\n  max-width: 600px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 16px;\n  backdrop-filter: blur(15px);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 12px 40px var(--shadow-dark);\n  position: relative;\n}\n\n.tutorial-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(50, 130, 184, 0.03) 0%, rgba(241, 143, 1, 0.03) 100%);\n  border-radius: 16px;\n  pointer-events: none;\n}\n\n.tutorial-go-back-btn {\n  margin-top: 2rem;\n  padding: 8px 16px;\n  font-size: 1.2rem;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  color: var(--text-primary);\n  transition: all 0.3s ease;\n  min-width: 120px;\n}\n\n.tutorial-go-back-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px var(--shadow-light);\n}\n\n.tutorial-go-back-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 6px var(--shadow-light);\n}\n\n/* Mobile First Responsive Design */\n@media (max-width: 480px) {\n  :root {\n  --base-node-size: 22px;\n  }\n  \n  body {\n    font-size: 1.4rem;\n  }\n  \n  .home-page__title {\n    font-size: 3.5rem;\n  }\n  \n  .loading-title h2 {\n    font-size: 3rem;\n  }\n  \n  .btn {\n    padding: 10px 20px;\n    font-size: 1.3rem;\n  }\n  \n  .icon_container {\n    width: 2rem;\n    height: 2rem;\n  }\n  \n  .board {\n    padding: 6px;\n    width: fit-content;\n    max-width: 100%;\n    overflow: hidden;\n    grid-template-columns: 22px 220px;\n    grid-template-rows: 22px 220px;\n  }\n  \n  .bot-player-board {\n    grid-template-columns: 220px 22px;\n    grid-template-rows: 22px 220px;\n  }\n  \n  .board-item-container {\n    grid-template-columns: repeat(10, 22px);\n    grid-template-rows: repeat(10, 22px);\n    width: 220px;\n    height: 220px;\n  }\n  \n  .row-label {\n    grid-template-columns: repeat(10, 22px);\n    width: 220px;\n    font-size: 0.8rem;\n  }\n  \n  .col-label {\n    grid-template-rows: repeat(10, 22px);\n    height: 220px;\n    font-size: 0.8rem;\n  }\n  \n  .label-item {\n    width: 22px;\n    height: 22px;\n    font-size: 0.7rem;\n    font-weight: 500;\n  }\n  \n  .board-item {\n    width: 22px !important;\n    height: 22px !important;\n    min-width: 22px !important;\n    min-height: 22px !important;\n    max-width: 22px !important;\n    max-height: 22px !important;\n  }\n  \n  .board-item-container {\n    padding: 6px;\n    gap: 1px;\n  }\n  \n  .water-header {\n    font-size: 2rem;\n  }\n  \n  .players-desc-container {\n    padding: 8px 16px;\n    gap: 1rem;\n  }\n  \n  .players-desc-container p {\n    font-size: 1.6rem;\n  }\n  \n  .ship-yard {\n    padding: 16px;\n  }\n  \n  .tutorial-container {\n    padding: 16px;\n    margin: 16px;\n  }\n  \n  .dialog-header {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .game-play-container .container {\n    padding: 0.3rem;\n    gap: 0.3rem;\n    height: 100vh;\n    max-height: 100vh;\n    flex: 1;\n  }\n  \n  .human-player-section-container,\n  .bot-player-section-container {\n    max-width: 100%;\n  }\n  \n  .game-dashboard-container {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    padding: 12px;\n  }\n  \n  .vertical-divider-container {\n    display: none !important;\n  }\n  \n  .small-screen_divider {\n    display: grid !important;\n  }\n  \n  .board {\n    margin: 0 auto;\n    max-width: 100%;\n    width: fit-content;\n    padding: 8px;\n    grid-template-columns: var(--base-node-size) calc(var(--base-node-size) * 10);\n    grid-template-rows: var(--base-node-size) calc(var(--base-node-size) * 10);\n  }\n  \n  .bot-player-board {\n    grid-template-columns: calc(var(--base-node-size) * 10) var(--base-node-size);\n    grid-template-rows: var(--base-node-size) calc(var(--base-node-size) * 10);\n  }\n  \n  .board-item-container {\n    grid-template-columns: repeat(10, var(--base-node-size));\n    grid-template-rows: repeat(10, var(--base-node-size));\n    gap: 0;\n    width: calc(var(--base-node-size) * 10);\n    height: calc(var(--base-node-size) * 10);\n  }\n  \n  .row-label {\n    grid-template-columns: repeat(10, var(--base-node-size));\n    font-size: 1rem;\n  }\n  \n  .col-label {\n    grid-template-rows: repeat(10, var(--base-node-size));\n    font-size: 1rem;\n  }\n  \n  .label-item {\n    width: var(--base-node-size);\n    height: var(--base-node-size);\n    font-size: 0.9rem;\n  }\n  \n  .ship-yard {\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n}\n\n@media (min-width: 768px) {\n  .settings-form .horizontal-divider-container .horizontal-divider {\n    display: block;\n  }\n\n  .settings-form .horizontal-divider:nth-of-type(1) {\n    width: 35%;\n  }\n\n  .settings-form .horizontal-divider:nth-of-type(2) {\n    width: 35%;\n  }\n\n  .settings-form h2 {\n    width: 30%;\n  }\n\n  .settings-modal h2 {\n    width: 100%;\n  }\n\n  .container {\n    width: 85%;\n  }\n  \n  .hidden_small {\n    display: block;\n  }\n}\n\n@media (min-width: 900px) {\n  html {\n    font-size: 12px;\n  }\n\n  dialog {\n    width: 60%;\n    max-width: 600px;\n  }\n\n  :root {\n    --base-node-size: 22px;\n  }\n\n  .container {\n    width: 85%;\n    max-width: 1200px;\n  }\n\n  .hidden_mid {\n    display: none;\n  }\n\n  .icon_container {\n    width: 35px;\n    height: 35px;\n  }\n\n  .row-label,\n  .col-label {\n    font-size: 2rem;\n  }\n\n  .btn-group {\n    padding: 12px 24px;\n    font-size: 2rem;\n  }\n\n  .game-setup .container {\n    flex-direction: row;\n    gap: 3rem;\n    align-items: flex-start;\n  }\n\n  .game-play-container {\n    height: 100vh;\n    overflow: hidden;\n  }\n\n  .game-play-container .container {\n    flex-direction: row;\n    gap: 2rem;\n    align-items: flex-start;\n    padding: 1rem;\n    min-height: calc(100vh - 2rem);\n  }\n\n  .game-play-container .vertical-divider-container {\n    display: grid;\n    min-width: 50px;\n  }\n\n  .human-player-section-container {\n    order: initial;\n    flex: 1;\n  }\n  \n  .bot-player-section-container {\n    flex: 1;\n  }\n\n  .bot-ship-yard-container {\n    max-width: 350px;\n    min-width: 280px;\n  }\n\n  .bot-ship-yard-container .ship-node {\n    width: 20px;\n    height: 20px;\n  }\n  \n  .board {\n    margin: 0;\n  }\n  \n  .ship-yard {\n    max-width: 350px;\n  }\n  \n  .home-page__title {\n    font-size: 5rem;\n  }\n  \n  .water-header {\n    font-size: 2.5rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  :root {\n    --base-node-size: 32px;\n  }\n  \n  .container {\n    width: 90%;\n    max-width: 1400px;\n  }\n  \n  .game-play-container .container {\n    gap: 3rem;\n    padding: 2rem 1rem;\n  }\n  \n  .board {\n    padding: 20px;\n  }\n  \n  .ship-yard {\n    padding: 24px;\n    max-width: 400px;\n  }\n  \n  .bot-ship-yard-container {\n    min-width: 320px;\n  }\n}\n\n/* ===============================================\n   DASHBOARD STYLES\n   =============================================== */\n\n.dashboard-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--primary-bg) 0%, var(--secondary-bg) 100%);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  animation: fadeIn 0.6s ease-out;\n}\n\n.dashboard-header {\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.dashboard-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--text-color);\n  margin: 0 0 0.5rem 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.username-highlight {\n  color: var(--accent-color);\n  background: linear-gradient(45deg, var(--accent-color), var(--secondary-accent));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-weight: 800;\n}\n\n.dashboard-subtitle {\n  font-size: 1.2rem;\n  color: var(--text-secondary);\n  margin: 0;\n  opacity: 0.9;\n}\n\n.section-title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--text-color);\n  margin: 0 0 1.5rem 0;\n  text-align: center;\n}\n\n/* Game Modes Section */\n.game-modes-section {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 2rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.game-modes-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.game-mode-card {\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 2rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.game-mode-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--accent-color), var(--secondary-accent));\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.game-mode-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.game-mode-card:hover::before {\n  opacity: 1;\n}\n\n.card-icon {\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 1rem auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(45deg, var(--accent-color), var(--secondary-accent));\n  border-radius: 50%;\n  color: white;\n}\n\n.card-icon svg {\n  width: 30px;\n  height: 30px;\n}\n\n.card-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-color);\n  margin: 0 0 0.5rem 0;\n  text-align: center;\n}\n\n.card-description {\n  color: var(--text-secondary);\n  text-align: center;\n  margin: 0 0 1rem 0;\n  line-height: 1.5;\n}\n\n.difficulty-options {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.difficulty-tag {\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.difficulty-tag.easy {\n  background: linear-gradient(45deg, #4ade80, #22c55e);\n  color: white;\n}\n\n.difficulty-tag.hard {\n  background: linear-gradient(45deg, #f87171, #ef4444);\n  color: white;\n}\n\n.online-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.online-indicator {\n  width: 8px;\n  height: 8px;\n  background: #22c55e;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n.online-count {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n}\n\n.tutorial-badge {\n  text-align: center;\n  margin-top: 1rem;\n}\n\n.tutorial-badge span {\n  background: linear-gradient(45deg, var(--accent-color), var(--secondary-accent));\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n/* Online Players Section */\n.online-players-section {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 2rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.players-container {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.players-count {\n  text-align: center;\n  color: var(--text-secondary);\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n}\n\n.players-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1rem;\n  min-height: 100px;\n}\n\n/* Empty Players Message Styling */\n.empty-players-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  text-align: center;\n  min-height: 120px;\n  grid-column: 1 / -1; /* Take full width in grid */\n}\n\n.empty-players-message .empty-icon {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  opacity: 0.6;\n}\n\n.empty-players-message .empty-text {\n  color: var(--text-primary);\n  font-size: 1rem;\n  font-weight: 500;\n  margin: 0 0 0.5rem 0;\n}\n\n.empty-players-message .empty-subtext {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  margin: 0;\n  font-style: italic;\n}\n\n.player-card {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.player-card:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.player-avatar {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(45deg, var(--accent-color), var(--secondary-accent));\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.player-info {\n  flex: 1;\n}\n\n.player-name {\n  color: var(--text-color);\n  font-weight: 500;\n  margin: 0 0 0.25rem 0;\n}\n\n.player-status {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  margin: 0;\n}\n\n/* User Actions Section */\n.user-actions-section {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.logout-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: var(--text-color);\n  padding: 0.75rem 1.5rem;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  backdrop-filter: blur(10px);\n}\n\n.logout-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n.logout-btn:hover {\n  background: rgba(239, 68, 68, 0.2);\n  border-color: rgba(239, 68, 68, 0.3);\n  transform: translateY(-2px);\n}\n\n\n\n/* AI Difficulty Modal */\n.ai-difficulty-modal {\n  border: none;\n  border-radius: 20px;\n  padding: 0;\n  background: linear-gradient(145deg, var(--primary-bg), var(--secondary-bg));\n  backdrop-filter: blur(20px);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 600px;\n  width: 90vw;\n}\n\n.ai-difficulty-modal::backdrop {\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  padding: 2rem;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.modal-title {\n  color: var(--text-color);\n  margin: 0;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.modal-close-btn {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.modal-close-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--text-color);\n}\n\n.modal-close-btn svg {\n  width: 24px;\n  height: 24px;\n}\n\n.difficulty-options-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.difficulty-option {\n  background: rgba(255, 255, 255, 0.05);\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 2rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.difficulty-option:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.2);\n  transform: translateY(-4px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.difficulty-option.easy-option:hover {\n  border-color: #22c55e;\n  box-shadow: 0 10px 30px rgba(34, 197, 94, 0.2);\n}\n\n.difficulty-option.hard-option:hover {\n  border-color: #ef4444;\n  box-shadow: 0 10px 30px rgba(239, 68, 68, 0.2);\n}\n\n.difficulty-icon {\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 1rem auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.easy-option .difficulty-icon {\n  background: linear-gradient(45deg, #4ade80, #22c55e);\n  color: white;\n}\n\n.hard-option .difficulty-icon {\n  background: linear-gradient(45deg, #f87171, #ef4444);\n  color: white;\n}\n\n.difficulty-icon svg {\n  width: 30px;\n  height: 30px;\n}\n\n.difficulty-option h3 {\n  color: var(--text-color);\n  margin: 0 0 0.5rem 0;\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n\n.difficulty-option p {\n  color: var(--text-secondary);\n  margin: 0 0 1rem 0;\n  line-height: 1.5;\n}\n\n.difficulty-features {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.difficulty-features li {\n  color: var(--text-secondary);\n  padding: 0.25rem 0;\n  font-size: 0.9rem;\n}\n\n.difficulty-features li::before {\n  content: '✓';\n  color: var(--accent-color);\n  font-weight: bold;\n  margin-right: 0.5rem;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.cancel-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: var(--text-color);\n  padding: 0.75rem 2rem;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.cancel-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n/* Dashboard Responsive Design */\n@media (max-width: 768px) {\n  .dashboard-container {\n    padding: 1rem;\n    gap: 1.5rem;\n  }\n  \n  .dashboard-title {\n    font-size: 2rem;\n  }\n  \n  .dashboard-subtitle {\n    font-size: 1rem;\n  }\n  \n  .game-modes-section,\n  .online-players-section {\n    padding: 1.5rem;\n  }\n  \n  .game-modes-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .game-mode-card {\n    padding: 1.5rem;\n  }\n  \n  .players-list {\n    grid-template-columns: 1fr;\n  }\n  \n  .user-actions-section {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .logout-btn {\n    width: 100%;\n    max-width: 300px;\n    justify-content: center;\n  }\n  \n  .modal-content {\n    padding: 1.5rem;\n  }\n  \n  .difficulty-options-container {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .difficulty-option {\n    padding: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard-title {\n    font-size: 1.8rem;\n  }\n  \n  .game-mode-card {\n    padding: 1rem;\n  }\n  \n  .card-icon {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .card-icon svg {\n    width: 24px;\n    height: 24px;\n  }\n  \n  .ai-difficulty-modal {\n    width: 95vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
